const eventsData = [
  {
    id: 1,
    title: "Tɛkyerɛma Pa Hackathon 2025",
    date: "February 17-21st, 2025",
    venue: "University of Ghana",
    overview:
      "Join us for the Tɛkyerɛma Pa Hackathon, an innovation-driven event aimed at designing and developing a groundbreaking app in Akan to support individuals with speech impairments. This hackathon invites tech enthusiasts, developers, linguists, and accessibility advocates to collaborate on creating a tool that empowers effective and inclusive communication for all.",
    description: [
      "Join us in our upcoming hackathon to showcase your skills, learn new things, and network with like-minded people. Participants will work to design a functional prototype that meets the following key goal:",
      "Seamless Integration of Speech Technologies: Incorporate advanced Text-to-Speech (TTS) or Automatic Speech Recognition (ASR) systems to support Akan language communication.",
      "User-Centric Interface Design: Build an intuitive and user-friendly interface tailored to individuals with speech impairments, ensuring cultural relevance and prioritizing inclusivity and ease of use.",
      "Accessibility Standards Compliance: Address diverse accessibility needs to enable seamless usage for individuals with varying levels of impairment.",
      "Scalable Language Support: Develop a scalable solution with the potential to expand to other Ghanaian languages.",
    ],
    image: "/hackathon.jpg",
    file: "/path-to-your-dataset/dataset-file.csv",
    rules: [
      "Each team is expected to have a maximum of 5 members.",
      "Each team must include at least one female participant.",
      "All code must be written during the hackathon.",
      "Prefarably, each team should have am individual with any form of speech impairment",
    ],
    prizes: [
      "Up to £5,000 in awards",
      "Mentorship opportunities with experts from Google and GDI Hub, University College of London",
      "A potential scholarship for an MSc in Computer Science",
    ],
    sponsors: [
      { sponsor: "GDI Hub, University College of London" },
      { image: "/gdi_hub.png" },
    ],
    url:"https://hci-lab-ugspeechdata.github.io/hack-tekyeremapa/"
  },
 
];

export default eventsData;
